import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
export function Trust() {
  const {
    t
  } = useLanguage();
  const pillars = t('trust.pillars') || [];
  return <section className="py-24 bg-white border-y border-black/5" data-id="element-173">
      <div className="container mx-auto px-6 md:px-12" data-id="element-174">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-175">
          <h2 className="text-2xl font-serif italic text-gold mb-4" data-id="element-176">
            {t('trust.heading')}
          </h2>
          <p className="text-black/60 font-light max-w-2xl mx-auto" data-id="element-177">
            {t('trust.intro')}
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16" data-id="element-178">
          {pillars.map((pillar: string, index: number) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center" data-id="element-179">
              <div className="w-px h-12 bg-gold/30 mx-auto mb-6" data-id="element-180"></div>
              <h3 className="text-sm font-medium tracking-wide uppercase text-[#0A0A0A]" data-id="element-181">
                {pillar}
              </h3>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center text-sm text-black/50" data-id="element-182">
          <p className="mb-4" data-id="element-183">{t('trust.closingNote')}</p>
          <div className="flex items-center justify-center gap-4 text-xs tracking-widest uppercase" data-id="element-184">
            <Link to="/privacy-policy" className="hover:text-gold transition-colors" data-id="element-185">
              {t('trust.privacyLink')}
            </Link>
            <span data-id="element-186">|</span>
            <Link to="/terms-and-conditions" className="hover:text-gold transition-colors" data-id="element-187">
              {t('trust.termsLink')}
            </Link>
          </div>
        </motion.div>
      </div>
    </section>;
}